import { arrayOf, shape, string } from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

export class LazyAssetRenderer extends PureComponent {
  constructor(props) {
    super(props);
    this.injected = {
      js: [],
      css: []
    };
  }

  componentDidMount() {
    this.props.js.map(this._appendJs);
    this.props.css.map(this._appendCss);
  }

  componentDidUpdate() {
    this.props.js.map(this._appendJs);
    this.props.css.map(this._appendCss);
  }

  _appendJs = ({ parentTag, uri }) => {
    if (this.injected.js.includes(uri)) {
      // Already injected
      return;
    }
    const parent = parentTag === 'head' ? document.head : document.body;
    const node = document.createElement('script');
    node.src = uri;
    node.async = true;
    parent.appendChild(node);
    this.injected.js.push(uri);
  };

  _appendCss = ({ parentTag, uri }) => {
    if (this.injected.css.includes(uri)) {
      // Already injected
      return;
    }
    const parent = parentTag === 'body' ? document.body : document.head;
    const node = document.createElement('link');
    node.href = uri;
    node.rel = 'stylesheet';
    parent.appendChild(node);
    this.injected.css.push(uri);
  };

  render() {
    return null;
  }
}

LazyAssetRenderer.defaultProps = {
  css: [],
  js: []
};

LazyAssetRenderer.propTypes = {
  css: arrayOf(shape({ parentTag: string, uri: string.isRequired })),
  js: arrayOf(shape({ parentTag: string, uri: string.isRequired }))
};

export default connect(({ assets }) => ({
  css: assets.css,
  js: assets.js
}))(LazyAssetRenderer);
